import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AuthContext } from '@/App';
import Workflow from '@/pages/Workflow';

const MyStuff = () => {
  const { user } = useContext(AuthContext);

  return (
    <div data-testid="my-stuff-page" className="space-y-8">
      <div className="panel-header">
        <div>
          <div className="panel-title">My stuff</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mt-3">
            Your current session
          </h1>
          <p className="text-sm md:text-lg text-[var(--text-secondary)] mt-2">
            Access your job setup, guided recommendations, and recent CNC-Helpdesk jobs.
          </p>
          {user && (
            <p className="text-sm text-[var(--text-muted)] mt-1">Signed in as {user.full_name}</p>
          )}
        </div>
      </div>

      <div className="divider" />

      {/* Job Calculator */}
      <div className="panel relative overflow-hidden">
        <div className="absolute inset-0 blueprint-grid opacity-10" />
        <div className="relative z-10">
          <div className="panel-header">
            <div>
              <div className="panel-title">Job Calculator</div>
              <h2 className="text-2xl md:text-3xl font-semibold mt-2">Feeds, speeds, and depth</h2>
              <p className="text-sm md:text-lg text-[var(--text-secondary)] mt-2">
                Open the CNC-Helpdesk job calculator to set cutting parameters before you run a job.
              </p>
            </div>
          </div>

          <Link to="/calculator" className="block primary-action primary-action-cta">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="primary-action-title">Open Job Calculator</div>
                <div className="primary-action-desc">Feeds, speeds, pass depth, step-over, export.</div>
                <div className="text-xs text-[var(--text-muted)] mt-1">Uses your Active Job Context</div>
              </div>
              <div className="btn btn-primary btn-lg">
                Job Calculator
                <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Guided recommendations note */}
      <div className="panel">
        <div className="panel-header">
          <div>
            <div className="panel-title">Guided recommendations</div>
            <div className="text-sm text-[var(--text-secondary)] mt-1">
              Suggested next steps based on your recent jobs and last calculation; shown on your Dashboard foreman console.
            </div>
          </div>
        </div>
        <p className="text-sm text-[var(--text-secondary)]">
          To review recommendations, open the Dashboard. This page is focused on direct access to setup and history.
        </p>
      </div>

      {/* Recent jobs: full workflow history & saved setups */}
      <Workflow />
    </div>
  );
};

export default MyStuff;
